import React, { Component } from "react";
import { Redirect } from "react-router";
import {
  MDBContainer, MDBCard, MDBCardBody, MDBBtn, MDBIcon,
  MDBRow, MDBCol, MDBTable, MDBTableBody, MDBTableHead
} from "mdbreact";
import { Bar, Doughnut, HorizontalBar, Line } from "react-chartjs-2";
import API_URL from '../config';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

class AdminControlDescargas extends Component {
  constructor(props) {
    super(props);
    var hoy = new Date();
    this.state = {
      filtro: 'hoy',
      fechaDesde: hoy.toISOString().split('T')[0],
      fechaHasta: hoy.toISOString().split('T')[0],
      operadorFiltro: '',
      datos: [],
      resumen: null,
      cargando: false,
      volverDashboard: false
    };
  }

  getToken = function() {
    var datos = this.props.location.state ? this.props.location.state.datos : null;
    if (!datos) { try { datos = JSON.parse(sessionStorage.getItem('datos')); } catch(e) { datos = null; } }
    return datos && datos[0] ? datos[0].autorizacion : "";
  }

  componentDidMount() {
    this.consultar('hoy');
  }

  consultar = function(tipo) {
    var token = this.getToken();
    var hoy = new Date();
    var desde = '';
    var hasta = hoy.toISOString().split('T')[0];

    if (tipo === 'hoy') {
      desde = hasta;
    } else if (tipo === 'semana') {
      var d = new Date(hoy);
      d.setDate(d.getDate() - 7);
      desde = d.toISOString().split('T')[0];
    } else if (tipo === 'mes') {
      desde = hoy.getFullYear() + '-' + String(hoy.getMonth() + 1).padStart(2, '0') + '-01';
    } else if (tipo === 'anio') {
      desde = hoy.getFullYear() + '-01-01';
    } else if (tipo === 'personalizado') {
      desde = this.state.fechaDesde;
      hasta = this.state.fechaHasta;
      if (!desde || !hasta) return;
    }

    this.setState({ cargando: true, filtro: tipo, fechaDesde: desde, fechaHasta: hasta });

    axios.post(API_URL + '/admin/reportedescargas/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ fecha_desde: desde, fecha_hasta: hasta, usuario_operador: this.state.operadorFiltro, autorizacion: token })
    })
    .then(function(response) {
      if (response.data) {
        this.setState({ datos: response.data.descargas || [], resumen: response.data.resumen || null, cargando: false });
      } else {
        this.setState({ cargando: false });
      }
    }.bind(this))
    .catch(function(err) { console.error(err); this.setState({ cargando: false }); }.bind(this));
  }

  exportarExcel = function() {
    if (this.state.datos.length === 0) return;
    var datosExcel = this.state.datos.map(function(d) {
      return {
        'Fecha': d.FechaDescarga,
        'Operador': d.UsuarioDescarga,
        'DNI Trabajador': d.DniTrabajador,
        'Comprobante': d.SerieNumero,
        'Periodo': d.Periodo,
        'Planilla': d.TipoPlanilla,
        'Monto (S/)': d.MontoPagado
      };
    });
    var ws = XLSX.utils.json_to_sheet(datosExcel);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Descargas');
    // Ajustar ancho de columnas
    ws['!cols'] = [
      { wch: 18 }, { wch: 15 }, { wch: 15 }, { wch: 18 }, { wch: 12 }, { wch: 12 }, { wch: 12 }
    ];
    var buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    var blob = new Blob([buf], { type: 'application/octet-stream' });
    saveAs(blob, 'Reporte_Descargas_' + this.state.fechaDesde + '_a_' + this.state.fechaHasta + '.xlsx');
  }

  // Datos para gráficos
  getGraficoOperadores = function() {
    var conteo = {};
    this.state.datos.forEach(function(d) {
      conteo[d.UsuarioDescarga] = (conteo[d.UsuarioDescarga] || 0) + 1;
    });
    var labels = Object.keys(conteo);
    var valores = labels.map(function(l) { return conteo[l]; });
    var colores = ['#7A1622', '#1565C0', '#2E7D32', '#F57C00', '#6A1B9A', '#00838F', '#C62828', '#4E342E'];
    return {
      labels: labels,
      datasets: [{ label: 'Descargas', data: valores, backgroundColor: colores.slice(0, labels.length), borderWidth: 0 }]
    };
  }

  getGraficoMontos = function() {
    var montos = {};
    this.state.datos.forEach(function(d) {
      montos[d.UsuarioDescarga] = (montos[d.UsuarioDescarga] || 0) + parseFloat(d.MontoPagado || 0);
    });
    var labels = Object.keys(montos);
    var valores = labels.map(function(l) { return Math.round(montos[l] * 100) / 100; });
    var colores = ['#1565C0', '#2E7D32', '#F57C00', '#7A1622', '#6A1B9A', '#00838F', '#C62828', '#4E342E'];
    return {
      labels: labels,
      datasets: [{ data: valores, backgroundColor: colores.slice(0, labels.length), borderWidth: 2, borderColor: '#fff' }]
    };
  }

  getGraficoTopTrabajadores = function() {
    var conteo = {};
    this.state.datos.forEach(function(d) {
      conteo[d.DniTrabajador] = (conteo[d.DniTrabajador] || 0) + 1;
    });
    var sorted = Object.entries(conteo).sort(function(a, b) { return b[1] - a[1]; }).slice(0, 10);
    return {
      labels: sorted.map(function(s) { return 'DNI ' + s[0]; }),
      datasets: [{ label: 'Descargas', data: sorted.map(function(s) { return s[1]; }), backgroundColor: '#1565C0', borderWidth: 0 }]
    };
  }

  getGraficoTendencia = function() {
    var porDia = {};
    this.state.datos.forEach(function(d) {
      var fecha = (d.FechaDescarga || '').substring(0, 10);
      porDia[fecha] = (porDia[fecha] || 0) + 1;
    });
    var labels = Object.keys(porDia).sort();
    var valores = labels.map(function(l) { return porDia[l]; });
    return {
      labels: labels,
      datasets: [{
        label: 'Descargas por día',
        data: valores,
        borderColor: '#7A1622',
        backgroundColor: 'rgba(122,22,34,0.1)',
        pointBackgroundColor: '#7A1622',
        pointRadius: 4,
        fill: true,
        tension: 0.3
      }]
    };
  }

  render() {
    var datos = this.props.location.state ? this.props.location.state.datos : null;
    if (!datos) { try { datos = JSON.parse(sessionStorage.getItem('datos')); } catch(e) { datos = null; } }
    if (!datos || !datos[0]) return <Redirect to="/" />;
    if (this.state.volverDashboard) return <Redirect push={false} to={{ pathname: "/admin-dashboard", state: { datos: datos } }} />;

    var resumen = this.state.resumen;
    var filtroActivo = this.state.filtro;
    var tieneDatos = this.state.datos.length > 0;

    var btnFiltro = function(tipo, label, icono) {
      return (
        <button type="button" onClick={function() { this.consultar(tipo); }.bind(this)}
          style={{
            borderRadius: '20px', margin: '0 3px', fontWeight: '600', fontSize: '0.8rem', padding: '7px 16px',
            backgroundColor: filtroActivo === tipo ? '#1565C0' : '#fff',
            color: filtroActivo === tipo ? '#fff' : '#555',
            border: filtroActivo === tipo ? 'none' : '1px solid #ddd', cursor: 'pointer',
            transition: 'all 0.2s'
          }}>
          {icono && <MDBIcon icon={icono} className="mr-1" />}{label}
        </button>
      );
    }.bind(this);

    // Estadísticas adicionales
    var promedioDia = 0;
    var operadorTop = '-';
    var maxDescargas = 0;
    if (tieneDatos) {
      var diasUnicos = {};
      var opConteo = {};
      this.state.datos.forEach(function(d) {
        diasUnicos[(d.FechaDescarga || '').substring(0, 10)] = true;
        opConteo[d.UsuarioDescarga] = (opConteo[d.UsuarioDescarga] || 0) + 1;
      });
      var numDias = Object.keys(diasUnicos).length || 1;
      promedioDia = Math.round(this.state.datos.length / numDias * 10) / 10;
      Object.keys(opConteo).forEach(function(op) {
        if (opConteo[op] > maxDescargas) { maxDescargas = opConteo[op]; operadorTop = op; }
      });
    }

    var chartOptions = {
      responsive: true, maintainAspectRatio: false,
      legend: { display: false },
      scales: { yAxes: [{ ticks: { beginAtZero: true, precision: 0 } }], xAxes: [{ ticks: { fontSize: 11 } }] }
    };
    var chartOptionsPie = { responsive: true, maintainAspectRatio: false, legend: { position: 'bottom', labels: { fontSize: 11 } } };
    var chartOptionsHBar = {
      responsive: true, maintainAspectRatio: false,
      legend: { display: false },
      scales: { xAxes: [{ ticks: { beginAtZero: true, precision: 0 } }], yAxes: [{ ticks: { fontSize: 11 } }] }
    };
    var chartOptionsLine = {
      responsive: true, maintainAspectRatio: false,
      legend: { display: false },
      scales: { yAxes: [{ ticks: { beginAtZero: true, precision: 0 } }], xAxes: [{ ticks: { fontSize: 10, maxRotation: 45 } }] }
    };

    return (
      <div style={{ minHeight: "calc(100vh - 4rem)", background: "#f0f2f5" }}>
        <MDBContainer className="pt-4 pb-4">
          <MDBBtn onClick={function() { this.setState({ volverDashboard: true }); }.bind(this)}
            style={{ borderRadius: '8px', margin: '0 0 16px 0', fontWeight: '500', fontSize: '0.85rem', padding: '8px 20px', background: '#7A1622', border: 'none', color: '#fff' }}>
            <MDBIcon icon="arrow-left" className="mr-2" />Volver al Panel
          </MDBBtn>

          {/* Header + Filtros */}
          <MDBCard style={{ borderRadius: '12px', border: 'none', boxShadow: '0 2px 12px rgba(21,101,192,0.12)', overflow: 'hidden' }}>
            <div style={{ background: 'linear-gradient(135deg, #1565C0, #1976D2)', padding: '14px 24px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <MDBIcon icon="chart-bar" style={{ color: '#fff', fontSize: '1.1rem' }} />
              <span style={{ color: '#fff', fontWeight: '600', fontSize: '0.95rem' }}>Control de Descargas de Operadores</span>
            </div>
            <MDBCardBody style={{ padding: '16px 24px' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px', marginBottom: '12px' }}>
                {btnFiltro('hoy', 'Hoy', 'calendar-day')}
                {btnFiltro('semana', 'Semana', 'calendar-week')}
                {btnFiltro('mes', 'Este Mes', 'calendar-alt')}
                {btnFiltro('anio', 'Este Año', 'calendar')}
                <span style={{ color: '#ccc', margin: '0 4px' }}>|</span>
                <input type="date" className="form-control form-control-sm" style={{ width: '140px', fontSize: '0.82rem' }}
                  value={this.state.fechaDesde} onChange={function(e) { this.setState({ fechaDesde: e.target.value }); }.bind(this)} />
                <span style={{ color: '#999', fontSize: '0.85rem' }}>a</span>
                <input type="date" className="form-control form-control-sm" style={{ width: '140px', fontSize: '0.82rem' }}
                  value={this.state.fechaHasta} onChange={function(e) { this.setState({ fechaHasta: e.target.value }); }.bind(this)} />
                {btnFiltro('personalizado', 'Filtrar', 'search')}
              </div>
              <MDBRow>
                <MDBCol md="3">
                  <input type="text" className="form-control form-control-sm" placeholder="Filtrar por operador..."
                    value={this.state.operadorFiltro} onChange={function(e) { this.setState({ operadorFiltro: e.target.value }); }.bind(this)}
                    style={{ fontSize: '0.82rem' }} />
                </MDBCol>
              </MDBRow>
            </MDBCardBody>
          </MDBCard>

          {/* Tarjetas Resumen */}
          {resumen && (
            <MDBRow className="mt-3">
              <MDBCol md="2">
                <MDBCard style={{ borderRadius: '10px', borderTop: '3px solid #1565C0' }}>
                  <MDBCardBody className="text-center py-3 px-2">
                    <MDBIcon icon="download" style={{ color: '#1565C0', fontSize: '1.3rem' }} />
                    <div style={{ fontSize: '1.6rem', fontWeight: '800', color: '#1565C0' }}>{resumen.TotalDescargas || 0}</div>
                    <small style={{ color: '#888', fontSize: '0.72rem' }}>Total Descargas</small>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
              <MDBCol md="2">
                <MDBCard style={{ borderRadius: '10px', borderTop: '3px solid #2E7D32' }}>
                  <MDBCardBody className="text-center py-3 px-2">
                    <MDBIcon icon="receipt" style={{ color: '#2E7D32', fontSize: '1.3rem' }} />
                    <div style={{ fontSize: '1.6rem', fontWeight: '800', color: '#2E7D32' }}>{resumen.TotalComprobantes || 0}</div>
                    <small style={{ color: '#888', fontSize: '0.72rem' }}>Comprobantes</small>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
              <MDBCol md="2">
                <MDBCard style={{ borderRadius: '10px', borderTop: '3px solid #F57C00' }}>
                  <MDBCardBody className="text-center py-3 px-2">
                    <MDBIcon icon="money-bill-wave" style={{ color: '#F57C00', fontSize: '1.3rem' }} />
                    <div style={{ fontSize: '1.4rem', fontWeight: '800', color: '#F57C00' }}>S/ {resumen.MontoTotal || '0.00'}</div>
                    <small style={{ color: '#888', fontSize: '0.72rem' }}>Monto Total</small>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
              <MDBCol md="2">
                <MDBCard style={{ borderRadius: '10px', borderTop: '3px solid #7A1622' }}>
                  <MDBCardBody className="text-center py-3 px-2">
                    <MDBIcon icon="users" style={{ color: '#7A1622', fontSize: '1.3rem' }} />
                    <div style={{ fontSize: '1.6rem', fontWeight: '800', color: '#7A1622' }}>{resumen.OperadoresActivos || 0}</div>
                    <small style={{ color: '#888', fontSize: '0.72rem' }}>Operadores</small>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
              <MDBCol md="2">
                <MDBCard style={{ borderRadius: '10px', borderTop: '3px solid #6A1B9A' }}>
                  <MDBCardBody className="text-center py-3 px-2">
                    <MDBIcon icon="chart-line" style={{ color: '#6A1B9A', fontSize: '1.3rem' }} />
                    <div style={{ fontSize: '1.6rem', fontWeight: '800', color: '#6A1B9A' }}>{promedioDia}</div>
                    <small style={{ color: '#888', fontSize: '0.72rem' }}>Promedio/Día</small>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
              <MDBCol md="2">
                <MDBCard style={{ borderRadius: '10px', borderTop: '3px solid #00838F' }}>
                  <MDBCardBody className="text-center py-3 px-2">
                    <MDBIcon icon="trophy" style={{ color: '#00838F', fontSize: '1.3rem' }} />
                    <div style={{ fontSize: '1rem', fontWeight: '800', color: '#00838F' }}>{operadorTop}</div>
                    <small style={{ color: '#888', fontSize: '0.72rem' }}>Top Operador</small>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
            </MDBRow>
          )}

          {/* Gráficos */}
          {tieneDatos && (
            <MDBRow className="mt-3">
              <MDBCol md="6" className="mb-3">
                <MDBCard style={{ borderRadius: '10px' }}>
                  <MDBCardBody>
                    <h6 style={{ color: '#7A1622', fontWeight: '600', marginBottom: '12px', fontSize: '0.88rem' }}>
                      <MDBIcon icon="chart-bar" className="mr-2" />Descargas por Operador
                    </h6>
                    <div style={{ height: '250px' }}>
                      <Bar data={this.getGraficoOperadores()} options={chartOptions} />
                    </div>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
              <MDBCol md="6" className="mb-3">
                <MDBCard style={{ borderRadius: '10px' }}>
                  <MDBCardBody>
                    <h6 style={{ color: '#1565C0', fontWeight: '600', marginBottom: '12px', fontSize: '0.88rem' }}>
                      <MDBIcon icon="chart-pie" className="mr-2" />Distribución de Montos por Operador
                    </h6>
                    <div style={{ height: '250px' }}>
                      <Doughnut data={this.getGraficoMontos()} options={chartOptionsPie} />
                    </div>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
              <MDBCol md="6" className="mb-3">
                <MDBCard style={{ borderRadius: '10px' }}>
                  <MDBCardBody>
                    <h6 style={{ color: '#2E7D32', fontWeight: '600', marginBottom: '12px', fontSize: '0.88rem' }}>
                      <MDBIcon icon="users" className="mr-2" />Top 10 Trabajadores Consultados
                    </h6>
                    <div style={{ height: '250px' }}>
                      <HorizontalBar data={this.getGraficoTopTrabajadores()} options={chartOptionsHBar} />
                    </div>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
              <MDBCol md="6" className="mb-3">
                <MDBCard style={{ borderRadius: '10px' }}>
                  <MDBCardBody>
                    <h6 style={{ color: '#F57C00', fontWeight: '600', marginBottom: '12px', fontSize: '0.88rem' }}>
                      <MDBIcon icon="chart-line" className="mr-2" />Tendencia de Descargas por Día
                    </h6>
                    <div style={{ height: '250px' }}>
                      <Line data={this.getGraficoTendencia()} options={chartOptionsLine} />
                    </div>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
            </MDBRow>
          )}

          {/* Tabla de descargas */}
          <MDBCard className="mt-3" style={{ borderRadius: '10px' }}>
            <MDBCardBody>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                <h6 style={{ color: '#1565C0', fontWeight: '600', margin: 0 }}>
                  <MDBIcon icon="list" className="mr-2" />Detalle de Descargas
                  {tieneDatos && <span style={{ color: '#999', fontWeight: '400', fontSize: '0.8rem', marginLeft: '8px' }}>({this.state.datos.length} registros)</span>}
                </h6>
                {tieneDatos && (
                  <button type="button" onClick={this.exportarExcel.bind(this)}
                    style={{ borderRadius: '8px', padding: '7px 18px', backgroundColor: '#2E7D32', border: 'none', color: '#fff', fontSize: '0.82rem', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <MDBIcon icon="file-excel" />Descargar Excel
                  </button>
                )}
              </div>
              {this.state.cargando ? (
                <div className="text-center py-4"><MDBIcon icon="spinner" spin size="2x" style={{ color: '#1565C0' }} /></div>
              ) : tieneDatos ? (
                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                  <MDBTable striped small responsive style={{ fontSize: '0.8rem' }}>
                    <MDBTableHead>
                      <tr style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 1 }}>
                        <th>Fecha</th>
                        <th>Operador</th>
                        <th>DNI Trabajador</th>
                        <th>Comprobante</th>
                        <th>Periodo</th>
                        <th>Planilla</th>
                        <th>Monto</th>
                      </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                      {this.state.datos.map(function(d, i) {
                        return (
                          <tr key={i}>
                            <td>{d.FechaDescarga}</td>
                            <td style={{ fontWeight: '600' }}>{d.UsuarioDescarga}</td>
                            <td>{d.DniTrabajador}</td>
                            <td>{d.SerieNumero}</td>
                            <td>{d.Periodo}</td>
                            <td>{d.TipoPlanilla}</td>
                            <td style={{ fontWeight: '600' }}>S/ {d.MontoPagado}</td>
                          </tr>
                        );
                      })}
                    </MDBTableBody>
                  </MDBTable>
                </div>
              ) : (
                <div className="text-center py-4">
                  <MDBIcon icon="inbox" size="2x" style={{ color: '#ccc' }} />
                  <p style={{ color: '#999', marginTop: '8px' }}>No se encontraron descargas en el periodo seleccionado</p>
                </div>
              )}
            </MDBCardBody>
          </MDBCard>
        </MDBContainer>
      </div>
    );
  }
}

export default AdminControlDescargas;
